import React, { useState } from 'react';
import { toast } from 'sonner';
import { Trash2 } from 'lucide-react';

const OPTIONS = [
  ['ours', 'We had to cancel', 'Deposit will be refunded. Customer is told why and that their deposit is coming back.'],
  ['customer', "Customer doesn't want the job", "Deposit kept to cover admin and driver costs. Customer is told it won't be refunded."],
];

// Cancel a booking, move it to the trash and email the customer. Used on the admin calendar and the driver portal.
export const CancelBooking = ({ job, authFetch, onDone }) => {
  const [open, setOpen] = useState(false);
  const [fault, setFault] = useState('');
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  const paid = !!(job.deposit_claimed_at || job.deposit_marked_paid || job.deposit_verified);
  const ref = job.ref || (job.id || '').slice(0, 6).toUpperCase();

  const submit = async () => {
    if (!window.confirm(`Cancel booking #${ref} for ${job.name || 'this customer'} and move it to the trash?${job.email ? ' The customer will be emailed.' : ''}`)) return;
    setBusy(true);
    try {
      const { data } = await authFetch('post', `/bookings/${job.id}/cancel-trash`, { fault, reason: reason.trim() });
      toast.success(`Booking cancelled and moved to trash.${data.refund_due ? ` £${data.deposit} deposit added to Deposit refunds.` : ''}${data.customer_emailed ? ' Customer emailed.' : ''}`);
      setOpen(false);
      onDone?.();
    } catch (e) {
      toast.error(typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : "Couldn't cancel the booking.");
    } finally { setBusy(false); }
  };

  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)} className="w-full mt-2 py-2 rounded-md font-bold text-sm inline-flex items-center justify-center gap-2 border border-red-300 text-red-700 hover:bg-red-50" data-testid={`cancel-booking-btn-${ref}`}>
        <Trash2 className="w-4 h-4" /> Cancel booking & move to trash
      </button>
    );
  }
  return (
    <div className="mt-2 rounded-lg border-2 border-red-300 bg-red-50/50 p-3 space-y-2" data-testid={`cancel-booking-form-${ref}`}>
      <div className="text-xs font-black uppercase tracking-wider text-red-800">Why is it cancelled?</div>
      {OPTIONS.map(([k, label, help]) => (
        <label key={k} className={`block rounded-md border p-2 cursor-pointer ${fault === k ? 'border-red-500 bg-white' : 'border-slate-200 bg-white/70'}`}>
          <span className="flex items-center gap-2 text-sm font-bold text-[color:var(--mv-navy)]"><input type="radio" name={`fault-${ref}`} checked={fault === k} onChange={() => setFault(k)} data-testid={`cancel-fault-${k}-${ref}`} />{label}</span>
          {paid && <span className="block text-[11px] text-slate-600 ml-5">{help}</span>}
        </label>
      ))}
      {!paid && <div className="text-[11px] text-slate-600">No deposit recorded for this booking, so no refund is needed.</div>}
      <textarea value={reason} onChange={(e) => setReason(e.target.value)} maxLength={300} rows={2} placeholder="Reason (shown to the customer in the email)" className="w-full rounded-md border border-slate-200 p-2 text-sm" data-testid={`cancel-reason-${ref}`} />
      <div className="flex gap-2">
        <button type="button" onClick={() => setOpen(false)} className="flex-1 h-10 rounded-md border border-slate-200 bg-white text-sm font-bold" data-testid={`cancel-back-${ref}`}>Keep booking</button>
        <button type="button" onClick={submit} disabled={busy || !fault || reason.trim().length < 3} className="flex-1 h-10 rounded-md bg-red-600 hover:bg-red-700 text-white text-sm font-bold disabled:opacity-50" data-testid={`cancel-confirm-${ref}`}>{busy ? 'Cancelling…' : 'Cancel & email customer'}</button>
      </div>
    </div>
  );
};
